import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/auth');
  };

  return (
    <div
      className="landing-page"
      style={{ backgroundImage: "url('/background.svg')" }}
    >
      {/* Top-right login button */}
      <button className="login-button" onClick={handleLogin}>
        Login
      </button>
    </div>
  );
};

export default LandingPage;
